import { useTranslation } from '@/core/hooks';
import { useMemo } from 'react';
import { getGuestLabels, type GuestLabels } from '../constants/getGuestLabels';

export function useGuestLabels(): GuestLabels {
  const { t } = useTranslation();
  return useMemo(() => getGuestLabels(t), [t]);
}
